import Affiliates from './services/affiliates'

window.affiliates = window.affiliates || new Affiliates()
